<div class="header-wrapper">
  <h2>{{ data.headerTranslationLabel | translate}}</h2>
  <button class="close" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div>
  <mat-form-field>
    <mat-label>{{ 'folders.name' | translate }}</mat-label>
    <input [formControl]="nameControl" placeholder="{{ 'folders.name' | translate }}" matInput>
    <mat-error *ngIf="nameControl.errors && (nameControl.dirty || nameControl.touched)" [ngStyle]="{'color': 'red'}">
      <div class="error" *ngIf="nameControl.hasError('required')">
        {{ 'validation.required' | translate: { name: ('folders.name' | translate) } }}
      </div>
      <div class="error" *ngIf="nameControl.hasError('maxlength')">
        {{ 'validation.max_length' | translate:{name: ('folders.name' | translate), max: nameControl.errors.maxlength.requiredLength } }}
      </div>
      <div class="error" *ngIf="nameControl.hasError('forbiddenSymbol')">
        {{ 'validation.is_not_valid' | translate:{name: ('folders.name' | translate) } }}
      </div>
      <div class="error" *ngIf="nameControl.hasError('nameExist')">
        {{ 'folders.validationName' | translate }}
      </div>
    </mat-error>
  </mat-form-field>
</div>

<div class="form-actions">
  <button class="cancel-button" (click)="dialogRef.close()" mat-button>{{ "system.cancel" | translate | uppercase }}</button>
  <button class="action-button" [disabled]="nameControl.invalid || nameControl.pristine" (click)="dialogRef.close(nameControl.value)" mat-raised-button>
    {{ "system.save" | translate | uppercase }}
  </button>
</div>
